/**
 * Pure fetch helper extracted from `useGetSpace` so the spaces sweet-state
 * store can call it from inside an action without depending on React or on
 * the hook itself.
 */
import { performHttpFetch } from '@atlassian/conversation-assistant-utils/httpUtils';

import type { SpaceResponse } from '../../controllers/space-store/types';

const SPACES_API_PATH = '/gateway/api/assist/rovo/v1/spaces';

export type GetSpaceFetchParams = {
	spaceId: string;
	cloudId: string;
	product: string;
	experienceId: string;
};

export const getSpaceFetchAction = async ({
	spaceId,
	cloudId,
	product,
	experienceId,
}: GetSpaceFetchParams): Promise<SpaceResponse> =>
	performHttpFetch({
		path: `${SPACES_API_PATH}/${spaceId}`,
		options: {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
		},
	});
